// eslint-disable-next-line import/no-extraneous-dependencies
import * as echarts from 'echarts'
import { Box } from '@mui/material'
import { useEffect, useMemo, useRef } from 'react'
import moment from 'moment'
import { getCurrency } from '../../../lib/currency'
import { averta } from '../../../asset/font'

const PriceChart = ({ lineData, isPC }) => {
  const chartRef = useRef(null)
  const chartInstanceRef = useRef(null)
  const divRef = useRef(null)

  const option = useMemo(() => {
    const { medianRentsPrice, yearMonth } = lineData
    return {
      grid: {
        top: 10,
        left: isPC ? 60 : 54,
        right: isPC ? 40 : 22
      },
      color: ['#88AE88'],
      tooltip: {
        trigger: 'axis',
        textStyle: {
          fontFamily: averta.style.fontFamily
        },
        extraCssText: 'border-radius: 12px;z-index: 5;'
      },
      xAxis: {
        type: 'category',
        axisLabel: {
          fontSize: isPC ? 16 : 14,
          color: '#75798D',
          fontFamily: averta.style.fontFamily
        },
        axisTick: {
          show: false // 设置为 false，去掉 X 轴每个刻度分隔的突出线
        },
        data: yearMonth?.map(dateValue =>
          dateValue ? moment(dateValue).format("MMM'YY").toUpperCase() : '--'
        ),
        boundaryGap: false,
        axisLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        interval: 500,
        min: 500,
        axisLabel: {
          // eslint-disable-next-line no-template-curly-in-string
          formatter: '${value}',
          fontSize: isPC ? 16 : 14,
          color: '#75798D',
          fontFamily: averta.style.fontFamily
        },
        axisTick: {
          show: false
        },
        axisLine: {
          // 坐标轴线线宽: 无效
          width: 2,
          // 坐标轴线样式
          lineStyle: {
            color: '#E0E2EF'
          }
        }
      },
      series: [
        {
          data: medianRentsPrice,
          type: 'line',
          lineStyle: {
            color: '#88AE88',
            width: 2
          },
          symbol: 'none',
          areaStyle: {
            color: '#D3DDCC80'
          },
          tooltip: {
            valueFormatter(value) {
              return (value ?? false) && value > 0 ? `$${getCurrency(value, 0) || '--'}` : '/'
            }
          }
        }
      ]
    }
  }, [lineData, isPC])

  useEffect(() => {
    if (!chartInstanceRef.current) {
      chartInstanceRef.current = echarts.init(chartRef.current)
    }

    const resizeHandler = () => {
      const divWidth = divRef.current.clientWidth
      chartInstanceRef.current.resize({ width: divWidth })
    }

    window.addEventListener('resize', resizeHandler)

    return () => {
      window.removeEventListener('resize', resizeHandler)
      chartInstanceRef.current.dispose()
    }
  }, [])

  useEffect(() => {
    if (chartInstanceRef.current) {
      chartInstanceRef.current.setOption(option)
    }
  }, [option])

  return (
    <Box ref={divRef} className="w-full h-full relative">
      <div ref={chartRef} style={{ width: '100%', height: '100%' }} />
    </Box>
  )
}

export default PriceChart
